import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockCheckModel } from "../stockCheckModel";
import { IStockCheckDetail } from "../stockCheckType";
import { useDictModel } from "@/views/base/dict/dictModel";
import { momentFormat } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from '@/model/globalModel'
import YhTootip from "@/components/YhTootip";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, reset
    } = useStockCheckModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onLook = (code: string) => {
        let supplierEditKey = "9-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    useEffect(() => {
        loadData()
    }, [])


    const columns: ColumnsType<IStockCheckDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1,
        }, {
            title: '盘库单号',
            width: 120,
            dataIndex: 'stocktakingCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onLook(text)} />,
        }, {
            title: '盘点状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '盘点类型',
            width: 80,
            dataIndex: 'type',
            render: (text) => text === 'trade-type.stocktaking.stt' ? '盘点单' : text === 'trade-type.stocktaking.init' ? '期初单' : ''
        }, {
            title: '盘点结果',
            width: 80,
            dataIndex: 'result',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '系统库存',
            width: 80,
            dataIndex: 'bookTotalNum',
        }, {
            title: '实际库存',
            width: 80,
            dataIndex: 'realTotalNum',
        }, {
            title: '盘盈总数',
            width: 80,
            dataIndex: 'surplusItem',
        }, {
            title: '盘亏总数',
            width: 80,
            dataIndex: 'lossItem',
        }, {
            title: '差异数量',
            width: 80,
            dataIndex: 'differenceTotalNum',
        }, {
            title: '差异金额',
            width: 80,
            dataIndex: 'differenceTotalAmount',
        },
        //  {
        //     title: '差异率',
        //     width: 80,
        //     dataIndex: 'differenceRateAll',
        //     render: (text) => text ? text + "%" : ""
        // },
        {
            title: '开始时间',
            width: 130,
            dataIndex: 'startTime',
            render: (text) => momentFormat(text)
        }, {
            title: '结束时间',
            width: 130,
            dataIndex: 'endTime',
            render: (text) => momentFormat(text)
        }, {
            title: '制单人',
            width: 70,
            dataIndex: 'createUser',
        }, {
            title: '制单时间',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '完成人',
            width: 70,
            dataIndex: 'finishUser',
        }, {
            title: '完成时间',
            width: 130,
            dataIndex: 'finishTime',
            render: (text) => momentFormat(text)
        }, {
            title: '审核人',
            width: 70,
            dataIndex: 'approvalUser',
        }, {
            title: '审核时间',
            width: 130,
            dataIndex: 'approvalTime',
            render: (text) => momentFormat(text)
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockCheck", "roleCodes": roles };
        return getRoleColumns("stockCheck", "主单", columns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            bordered
            size={tableSize}
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockCheckDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}
